import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const FSMModule = () => (
  <DSDModuleSubtopic
    title="Finite State Machines (Mealy & Moore) and Sequence Detection"
    videos={[
      "https://www.youtube.com/embed/OVTjSu1jK48",
      "https://www.youtube.com/embed/kb-Ww8HaHuE",
      "https://www.youtube.com/embed/ublVFRXOdZo",
      "https://www.youtube.com/embed/PbjntQf3sGc",
      "https://www.youtube.com/embed/kfjNQNd3iAA",
      "https://www.youtube.com/embed/ogDldQlG0L8",
      "https://www.youtube.com/embed/wbUcIgg4Sdk",
      "https://www.youtube.com/embed/hya-DkRkNbQ",
      "https://www.youtube.com/embed/tzxaf-CNU3Q"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "The sequential circuit shown below has one input X and one output Z. Identify whether the circuit is a Mealy or Moore sequential circuit. Draw the state diagram and write the next state table. Derive the next state and output equations.",
        image:"/dsd_22.png"
      },
      {
        text: "The code below should implement a simple four state FSM which increments a 4-bit synchronous counter when the FSM is in state 2'b10. Identify the major problem with this code and propose a solution to fix the problem. You can define a new variable if necessary.",
        image:"/dsd_23.png"
      },
      {
        text: "Design a Mealy sequential circuit whose output is 1 whenever the input sequence ends with 1001. Design the circuit using T Flip-Flops."
      },
      {
        text: "Consider the circuit shown below. (a) Construct a state table and state diagram. Is the circuit a Mealy or Moore circuit? Does the circuit have any unused states? Assume 00 as the initial state. (b) Draw the timing diagram for the input sequence X = 01100. (c) What is the output sequence for the input sequence given in (b)?",
        image:"/dsd_24.png"
      },
      {
        text: "Design a Mealy sequence detector to detect the sequence 1101 using D Flip-Flops."
      },
      {
        text: "Design a sequential circuit to detect the sequence 101 (without overlapping) using D Flip-Flops."
      },
      {
        text: "Design a system that detects the occurrence of 101. The system input and output signals are given below.",
        image:"/dsd_26.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default FSMModule;
